
import { ConfigTabProps } from "./types";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { AgentTone } from "@/components/candidates/types/agent";

export const BehaviorConfigTab = ({ selectedAgent, updateAgentConfig }: ConfigTabProps) => {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="agent-tone">Communication Tone</Label>
        <Select 
          value={selectedAgent.tone}
          onValueChange={(value) => updateAgentConfig({ tone: value as AgentTone })}
        >
          <SelectTrigger id="agent-tone">
            <SelectValue placeholder="Select tone" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="professional">Professional</SelectItem>
            <SelectItem value="friendly">Friendly</SelectItem>
            <SelectItem value="technical">Technical</SelectItem>
            <SelectItem value="concise">Concise</SelectItem>
            <SelectItem value="detailed">Detailed</SelectItem>
          </SelectContent>
        </Select>
      </div>
      
      <div className="grid gap-4 pt-2">
        <div className="flex items-center justify-between">
          <div>
            <Label htmlFor="proactive-mode" className="font-medium">Proactive Mode</Label>
            <p className="text-sm text-muted-foreground">
              Allow agent to initiate conversations based on triggers
            </p>
          </div>
          <Switch id="proactive-mode" defaultChecked />
        </div>
        
        <div className="flex items-center justify-between">
          <div>
            <Label htmlFor="user-feedback" className="font-medium">Learn from User Feedback</Label>
            <p className="text-sm text-muted-foreground">
              Improve responses based on user interactions
            </p>
          </div>
          <Switch id="user-feedback" defaultChecked />
        </div>
        
        <div className="flex items-center justify-between">
          <div>
            <Label htmlFor="multi-step" className="font-medium">Multi-step Planning</Label>
            <p className="text-sm text-muted-foreground">
              Break complex tasks into manageable steps
            </p>
          </div>
          <Switch id="multi-step" defaultChecked />
        </div>
      </div>
      
      <div className="space-y-2 pt-2">
        <Label htmlFor="response-length">Response Length Preference</Label>
        <Select defaultValue="balanced">
          <SelectTrigger id="response-length">
            <SelectValue placeholder="Select preference" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="brief">Brief</SelectItem>
            <SelectItem value="balanced">Balanced</SelectItem>
            <SelectItem value="detailed">Detailed</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};
